import { createReducer, createSelector, on } from '@ngrx/store';
import { CompanySegmentationDTO, CustomerSegmentationEntryDTO } from '@iota/inh-core-v1-management-client';
import {
    LoadCustomerSegmentationOptions,
    LoadCustomerSegmentationOptionsSuccess,
    LoadCustomerSegmentationOptionsFailure,
    LoadCompanySegmentation,
    LoadCompanySegmentationSuccess,
    LoadCompanySegmentationFailure,
    CreateCompanySegmentation,
    CreateCompanySegmentationSuccess,
    CreateCompanySegmentationFailure,
    UpdateCompanySegmentation,
    UpdateCompanySegmentationSuccess,
    UpdateCompanySegmentationFailure
} from '../actions/customer-segmentation.actions';
import { AppState } from '../store';

export interface CustomerSegmentationState {
    loading: boolean;
    actionLoading: boolean;
    optionsLoading: boolean;
    companySegmentation: CompanySegmentationDTO | null;
    industries: CustomerSegmentationEntryDTO[];
    tariffModels: CustomerSegmentationEntryDTO[];
    enterpriseSizes: CustomerSegmentationEntryDTO[];
    bgmMaturityLevels: CustomerSegmentationEntryDTO[];
    error: any;
}

export const initialState: CustomerSegmentationState = {
    loading: false,
    actionLoading: false,
    optionsLoading: false,
    companySegmentation: null,
    industries: [],
    tariffModels: [],
    enterpriseSizes: [],
    bgmMaturityLevels: [],
    error: null
};

export const customerSegmentationReducer = createReducer(
    initialState,

    on(LoadCustomerSegmentationOptions, (state) => ({
        ...state,
        optionsLoading: true,
        error: null
    })),
    on(LoadCustomerSegmentationOptionsSuccess, (state, { industries, tariffModels, enterpriseSizes, bgmMaturityLevels }) => ({
        ...state,
        optionsLoading: false,
        industries,
        tariffModels,
        enterpriseSizes,
        bgmMaturityLevels,
        error: null
    })),
    on(LoadCustomerSegmentationOptionsFailure, (state, { error }) => ({
        ...state,
        optionsLoading: false,
        error
    })),

    // Load company segmentation
    on(LoadCompanySegmentation, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(LoadCompanySegmentationSuccess, (state, { segmentation }) => ({
        ...state,
        loading: false,
        companySegmentation: segmentation,
        error: null
    })),
    on(LoadCompanySegmentationFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    on(CreateCompanySegmentation, (state) => ({
        ...state,
        actionLoading: true,
        error: null
    })),
    on(CreateCompanySegmentationSuccess, (state, { segmentation }) => ({
        ...state,
        actionLoading: false,
        companySegmentation: segmentation,
        error: null
    })),
    on(CreateCompanySegmentationFailure, (state, { error }) => ({
        ...state,
        actionLoading: false,
        error
    })),

    on(UpdateCompanySegmentation, (state) => ({
        ...state,
        actionLoading: true,
        error: null
    })),
    on(UpdateCompanySegmentationSuccess, (state, { segmentation }) => ({
        ...state,
        actionLoading: false,
        companySegmentation: segmentation,
        error: null
    })),
    on(UpdateCompanySegmentationFailure, (state, { error }) => ({
        ...state,
        actionLoading: false,
        error
    }))
);

const selectCustomerSegmentationState = (state: AppState) => state.customerSegmentation;

export const customerSegmentationLoading = createSelector(selectCustomerSegmentationState, (state) => state.loading);

export const customerSegmentationActionLoading = createSelector(selectCustomerSegmentationState, (state) => state.actionLoading);

export const customerSegmentationOptionsLoading = createSelector(selectCustomerSegmentationState, (state) => state.optionsLoading);

export const companySegmentation = createSelector(selectCustomerSegmentationState, (state) => state.companySegmentation);

export const customerSegmentationIndustries = createSelector(selectCustomerSegmentationState, (state) => state.industries);

export const customerSegmentationTariffModels = createSelector(selectCustomerSegmentationState, (state) => state.tariffModels);

export const customerSegmentationEnterpriseSizes = createSelector(selectCustomerSegmentationState, (state) => state.enterpriseSizes);

export const customerSegmentationBgmMaturityLevels = createSelector(selectCustomerSegmentationState, (state) => state.bgmMaturityLevels);

export const customerSegmentationError = createSelector(selectCustomerSegmentationState, (state) => state.error);
